import React, { useState } from 'react';
import Encabezado from './Encabezado';
import Tabla from './Tabla';

function MainEmpresas(){

    const [idInscripcion, setIdInscripcion]=useState(-1); 
    const [search, setSearch]=useState(""); 
    
    return(  
        <>  
            <div className='container container-width-85 containerEmpresas'>
                <Encabezado seccionId={2} setIdInscripcion={setIdInscripcion} search={search} setSearch={setSearch}/>  
                <Tabla seccionId={2} idInscripcion={idInscripcion} search={search} setSearch={setSearch}/>
            </div>
        </>
    );
}


export default MainEmpresas;